import { render, staticRenderFns } from "./select-user-tag.vue?vue&type=template&id=4287ce74&scoped=true"
import script from "./select-user-tag.vue?vue&type=script&lang=js"
export * from "./select-user-tag.vue?vue&type=script&lang=js"
import style0 from "./select-user-tag.vue?vue&type=style&index=0&id=4287ce74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4287ce74",
  null
  
)

export default component.exports